/**
 * @generated SignedSource<<a95d053e6db7527acf21bf98d02992ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ReleaseTypeEnum = "album" | "compilation" | "single";
import { FragmentRefs } from "relay-runtime";
export type DealAnalysis_featuredDeal$data = {
  readonly releases: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name?: string;
        readonly releaseType?: ReleaseTypeEnum | null;
        readonly " $fragmentSpreads": FragmentRefs<"useReleaseMetadata_release">;
      } | null;
    } | null>;
  };
  readonly streamsPerDay: number | null;
  readonly unreleasedReleases: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name?: string;
        readonly releaseType?: ReleaseTypeEnum | null;
        readonly " $fragmentSpreads": FragmentRefs<"useReleaseMetadata_release">;
      } | null;
    } | null>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"RecoupmentProfile_featuredDeal" | "ReturnProfile_featuredDeal">;
  readonly " $fragmentType": "DealAnalysis_featuredDeal";
};
export type DealAnalysis_featuredDeal$key = {
  readonly " $data"?: DealAnalysis_featuredDeal$data;
  readonly " $fragmentSpreads": FragmentRefs<"DealAnalysis_featuredDeal">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseType",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useReleaseMetadata_release"
      }
    ],
    "type": "ReleaseInterface",
    "abstractKey": "__isReleaseInterface"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DealAnalysis_featuredDeal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streamsPerDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReleaseNodeConnection",
      "kind": "LinkedField",
      "name": "releases",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReleaseNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ReleaseNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnreleasedReleaseNodeConnection",
      "kind": "LinkedField",
      "name": "unreleasedReleases",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnreleasedReleaseNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UnreleasedReleaseNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReturnProfile_featuredDeal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecoupmentProfile_featuredDeal"
    }
  ],
  "type": "FeaturedDealNode",
  "abstractKey": null
};
})();

(node as any).hash = "eabd803ff926edcb70082e47f0aa48f8";

export default node;
